import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      boxShadow: '3px 0px 15px rgba(78, 81, 97, 0.14)',
      width: '100%',
    },
    table: {
      minWidth: 800,
      '& .MuiTableCell-root': {
        fontSize: '14px',
      },
    },
    tableItem: {
      padding: '8px',
    },
    blurred: {
      filter: `blur(10px)`,
    },
    action: {
      minWidth: '20px',
    },
    tableChip: {
      height: '23px',
      width: '70px',
      fontSize: '11px',
      backgroundColor: theme.palette.success.main,
    },
    tableChipRole: {
      height: '23px',
      width: '70px',
      fontSize: '11px',
      backgroundColor: theme.palette.primary.main,
    },
    tableChipRoleWarning: {
      backgroundColor: theme.palette.warning.main,
    },
    tableChipError: {
      backgroundColor: theme.palette.error.main,
    },
    tableWrap: {
      boxShadow: 'none',
    },
    tableHeader: {
      padding: '14px 8px',
      fontWeight: 'bold',
    },
    tableRowName: {
      display: 'flex',
      alignItems: 'center',
    },
    tableRowAvatar: {
      margin: '5px',
      width: '30px',
      height: '30px',
    },
    button: {
      padding: '12px 27px',
      textTransform: 'capitalize',
      lineHeight: '19px',
      width: '100%',
      maxWidth: '108px',
      marginBottom: '-19px',
      marginRight: '16px',
      maxHeight: '39px',
    },
    content: {
      display: 'flex',
      alignItems: 'flex-end',
      width: '100%',
      flexDirection: 'column',
      marginTop: '-15px',
    },
    mainContent: {
      display: 'flex',
      alignItems: 'flex-end',
      width: '100%',
      flexDirection: 'column',
      marginTop: '30px',
    },
    memberCell: {
      display: 'flex',
      alignItems: 'center',
    },
    idColumn: {
      width: '300px',
    },
    memberAvatar: {
      transitionDuration: '0.5s',
      '&:focus, &:active, &:hover': {
        [theme.breakpoints.up('sm')]: {
          transform: 'scale(1.3)',
          transitionDuration: '0.5s',
        },
      },
    },
    buttonLink: {
      textDecoration: 'none',
      color: theme.palette.common.white,
    },
    memberTooltip: {
      fontSize: '14px',
      cursor: 'pointer',
      '&.MuiTooltip-tooltipPlacementBottom': {
        padding: '10px',
        marginTop: '14px',
      },
    },

    projectName: {
      textTransform: 'none',
      minWidth: '10px',
      padding: 0,
      color: theme.palette.primary.main,
    },
    task: {
      fontSize: 14,
      fontWeight: 700,
      lineHeight: '20px',
    },
    bugFixing: {
      color: '#EBB9AE',
    },
    status: {
      display: 'flex',
      justifyContent: 'center',
      padding: '4px 2px',
      borderRadius: '21px',
    },
    pending: {
      color: '#F09438',
      background: 'rgba(240, 148, 56, 0.1)',
    },
    approved: {
      color: '#61D8A9',
      background: 'rgba(97, 216, 169, 0.1)',
    },
    rejected: {
      color: '#D55F4D',
      background: 'rgba(216, 80, 60, 0.1)',
    },
    membersBlock: {
      display: 'flex',
      flexWrap: 'wrap',
      maxWidth: '300px',
    },
  }),
);

export default useStyles;
